/**
 * CustomProse — 커스텀 섹션 본문 렌더 (목업 `.prose`).
 *
 * 순수 프레젠테이션.
 *   - html: 반드시 정화 후 렌더 → sanitizeHtml(XSS 방지) + sanitizeContentText(이모지 제거)
 *           경유 후 dangerouslySetInnerHTML. 외부링크 rel 정책 등은 sanitizeHtml 이 처리.
 *   - text: HTML 이 아닌 일반 텍스트. 그대로 문단(<p>)으로 렌더.
 * html 이 있으면 우선한다.
 */

import React from 'react';
import { sanitizeHtml } from '../../../utils/sanitizeHtml';
import { sanitizeContentText } from '../../../domain/property/formatters';

export interface CustomProseProps {
  html?: string | null;
  text?: string | null;
  className?: string;
}

const PROSE_CLASS =
  'text-[13px] leading-[1.6] text-body [&_b]:font-bold [&_b]:text-ink [&_strong]:font-bold [&_strong]:text-ink';

export function CustomProse({ html, text, className = '' }: CustomProseProps) {
  const wrapper = `${PROSE_CLASS} ${className}`.trim();

  if (html) {
    // XSS 정화 후 이모지 제거 (정보형 UI 이모지 금지 정책)
    const clean = sanitizeContentText(sanitizeHtml(html));
    return <div className={wrapper} dangerouslySetInnerHTML={{ __html: clean }} />;
  }

  if (text) {
    return (
      <div className={wrapper}>
        <p className="whitespace-pre-line">{text}</p>
      </div>
    );
  }

  return null;
}

export default CustomProse;
